import {Paper, Typography, Box} from '@mui/material';
import {cardStyle} from '../../styles';
import ShoppingIcon from '$assets/svgs/shopping-icon.svg?react';

import {
  titleStyle,
  cardContentStyle,
  companyItemStyle,
  rankStyle,
  companyNameStyle,
  claimsInfoStyle,
  lastCompanyItemStyle,
} from './styles';
import {DashboardData} from '$api/finance/dashboard';

interface TopInsuranceCompaniesCardProps {
  data: DashboardData;
}

const TopInsuranceCompaniesCard: React.FC<TopInsuranceCompaniesCardProps> = ({
  data,
}) => {
  const {top_insurance_companies} = data;
  return (
    <Paper sx={cardStyle}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
        <ShoppingIcon />
        <Typography variant="h6" sx={titleStyle}>
          Top 3 insurance companies
        </Typography>
      </Box>
      <Box sx={cardContentStyle}>
        {(top_insurance_companies || []).slice(0, 3).map((company, idx) => (
          <Box
            key={company.company_name}
            sx={idx === 2 ? lastCompanyItemStyle : companyItemStyle}
          >
            <Typography sx={rankStyle}>{idx + 1}°</Typography>
            <Box>
              <Typography sx={companyNameStyle}>
                {company.company_name}
              </Typography>
              <Typography sx={claimsInfoStyle}>
                {company.open_claims || 0} open claims (£
                {(company.total_claimed || 0).toLocaleString()} total)
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default TopInsuranceCompaniesCard;
